var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_center"},[_c('vcheckbox',{staticClass:"margin_right",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_vm._v(" "),_c('agree-text-index',{attrs:{"country":_vm.country}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }